import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer({ lang, onReopenCookies }) {
  const { t } = useTranslation();
  const basePath = `/${lang}`;

  const handleAnchor = (e, hash) => {
    if (window.location.pathname === basePath || window.location.pathname === `${basePath}/`) {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-brand-row">
            <svg className="brand-mark" viewBox="0 0 40 40" aria-hidden="true">
              <rect x="6" y="18" width="6" height="18" fill="currentColor" />
              <rect x="14" y="12" width="6" height="24" fill="currentColor" />
              <rect x="22" y="6" width="6" height="30" fill="currentColor" />
              <rect x="30" y="16" width="4" height="20" fill="currentColor" />
              <circle cx="34" cy="10" r="3" fill="#a63d1e" />
            </svg>
            <span className="brand-name-footer">Ronavirexa</span>
          </div>
          <p className="footer-tagline">{t("footer.tagline")}</p>
          <p className="footer-risk">{t("footer.riskNotice")}</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">{t("footer.navTitle")}</h4>
          <a href={`${basePath}#about`} onClick={(e) => handleAnchor(e, "about")} className="footer-link">{t("nav.about")}</a>
          <a href={`${basePath}#how`} onClick={(e) => handleAnchor(e, "how")} className="footer-link">{t("nav.how")}</a>
          <a href={`${basePath}#projects`} onClick={(e) => handleAnchor(e, "projects")} className="footer-link">{t("nav.projects")}</a>
          <a href={`${basePath}#contact`} onClick={(e) => handleAnchor(e, "contact")} className="footer-link">{t("nav.contact")}</a>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">{t("footer.legalTitle")}</h4>
          <Link to={`${basePath}/privacy`} className="footer-link" data-testid="footer-privacy">{t("nav.privacy")}</Link>
          <Link to={`${basePath}/cookies`} className="footer-link" data-testid="footer-cookies">{t("nav.cookies")}</Link>
          <Link to={`${basePath}/terms`} className="footer-link" data-testid="footer-terms">{t("nav.terms")}</Link>
          <button type="button" className="footer-link footer-link-btn" onClick={onReopenCookies} data-testid="footer-reopen-cookies">
            {t("cookiesPage.reopenButton")}
          </button>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">{t("footer.contactTitle")}</h4>
          <a href="mailto:hola@ronavirexa.com" className="footer-link footer-link-icon">
            <Mail size={14} /> hola@ronavirexa.com
          </a>
          <a href="tel:+541148920415" className="footer-link footer-link-icon">
            <Phone size={14} /> +54 11 4892-0415
          </a>
          <div className="footer-link footer-link-icon footer-address">
            <MapPin size={14} /> <span>{t("footer.address")}</span>
          </div>
        </div>
      </div>

      <div className="footer-legal">
        <div className="footer-legal-row">
          <span className="footer-legal-company">{t("footer.companyName")}</span>
        </div>
        <div className="footer-legal-grid">
          <div><span className="legal-label">{t("footer.registrationLabel")}</span><span className="legal-value">{t("footer.registrationValue")}</span></div>
          <div><span className="legal-label">{t("footer.taxLabel")}</span><span className="legal-value">{t("footer.taxValue")}</span></div>
          <div><span className="legal-label">{t("footer.licenseLabel")}</span><span className="legal-value">{t("footer.licenseValue")}</span></div>
          <div><span className="legal-label">{t("footer.jurisdictionLabel")}</span><span className="legal-value">{t("footer.jurisdictionValue")}</span></div>
          <div><span className="legal-label">{t("footer.incorporationLabel")}</span><span className="legal-value">{t("footer.incorporationValue")}</span></div>
        </div>
        <p className="footer-copyright">{t("footer.copyright")}</p>
      </div>
    </footer>
  );
}
